import React from 'react';
import Footer from '../../components/layout/Footer';

import HeaderMeta from 'components/headerMeta/HeaderMeta';
import '../../assets/style/itemStyle/common.scss';

const EmptyLegPolicy = () => {
  return (
    <>
      <HeaderMeta type="emptyLegs" />
      <div className="privacy-policy-content">
        <p style={{ textAlign: 'center' }}>
          <h1 style={{ textDecoration: 'underline' }}>AIRACER EMPTY LEG BOOKING POLICY</h1>
        </p>

        <h2 id="1-overview">1. Overview</h2>
        <p>
          Empty Leg flights are repositioning flights operated by an aircraft that would otherwise
          fly without passengers. These flights may be offered at a reduced rate, subject to
          operational constraints and availability.
        </p>
        <p>
          All Empty Leg bookings arranged through Airacer are subject to this policy, together with
          any booking-specific terms, operator terms, and applicable charter documents.
        </p>

        <h2 id="2-nature-of-empty-leg-flights">2. Nature of Empty Leg Flights</h2>
        <p>
          Empty Leg flights are opportunistic inventory based on an aircraft’s existing operational
          schedule.
        </p>
        <p>
          As a result, Empty Leg flights are inherently less flexible and less predictable than
          standard charter bookings.
        </p>
        <p>
          Availability of any Empty Leg flight is not guaranteed until confirmed in writing by
          Airacer and the operating carrier.
        </p>

        <h2 id="3-schedule-and-routing-flexibility">3. Schedule and Routing Flexibility</h2>
        <p>
          Empty Leg flights are tied to the operator’s operational needs. Departure time, arrival
          time, routing, and airport availability may be adjusted, delayed, or canceled based on the
          requirements of the primary revenue flight, aircraft positioning needs, crew limitations,
          airport restrictions, weather, or other operational considerations.
        </p>
        <p>
          Customers booking an Empty Leg flight must be prepared for a reasonable degree of schedule
          flexibility.
        </p>
        <p>
          Airacer does not guarantee that an Empty Leg flight will operate exactly as initially
          displayed or quoted.
        </p>

        <h2 id="4-availability-and-confirmation">4. Availability and Confirmation</h2>
        <p>
          All Empty Leg listings, quotes, and flight details are subject to prior sale, operator
          confirmation, aircraft availability, and operational review.
        </p>
        <p>
          A booking is not considered confirmed unless and until Airacer provides written
          confirmation.
        </p>
        <p>
          Airacer reserves the right to withdraw or amend any Empty Leg offer prior to written
          confirmation.
        </p>

        <h2 id="5-pricing">5. Pricing</h2>
        <p>
          Empty Leg pricing is based on limited and dynamic inventory and may change at any time
          before booking confirmation.
        </p>
        <p>Unless otherwise expressly stated in writing:</p>
        <ul>
          <li>Empty Leg pricing is subject to aircraft availability and operator confirmation</li>
          <li>
            quoted pricing may exclude taxes, regulatory fees, airport fees, FBO charges, de-icing,
            international handling, or other variable costs
          </li>
          <li>
            final pricing may vary depending on routing, timing, passenger requirements, baggage,
            ground conditions, and other trip-specific factors
          </li>
        </ul>
        <p>Any final amount payable will be confirmed at the time of booking.</p>

        <h2 id="6-use-of-airacer-credits">6. Use of Airacer Credits</h2>
        <p>
          Airacer Credits may not be applied toward Empty Leg flights unless Airacer expressly
          approves such use in writing.
        </p>
        <p>
          Any exception approved by Airacer shall apply only to the specific booking expressly
          identified in writing and shall not constitute a waiver for any future booking.
        </p>

        <h2 id="7-passenger-and-baggage-limits">7. Passenger and Baggage Limits</h2>
        <p>
          All passenger capacity, baggage allowance, and payload limits remain subject to the actual
          operating limitations of the aircraft.
        </p>
        <p>
          Passengers may not bring baggage, pets, or other items in excess of what the aircraft can
          lawfully and safely carry.
        </p>
        <p>
          Airacer and the operator reserve the right to review and limit baggage, pet transport, and
          special items based on aircraft type, payload, routing, and safety requirements.
        </p>

        <h2 id="8-airport-and-aircraft-changes">8. Airport and Aircraft Changes</h2>
        <p>
          Because Empty Leg flights are operationally driven, Airacer and/or the operator may
          substitute:
        </p>
        <ul>
          <li>aircraft type</li>
          <li>airport</li>
          <li>schedule</li>
          <li>routing</li>
        </ul>
        <p>where reasonably necessary for operational, safety, or regulatory reasons.</p>
        <p>Any such change will be communicated as soon as reasonably possible.</p>

        <h2 id="9-cancellation-or-change-by-operator">9. Cancellation or Change by Operator</h2>
        <p>
          An Empty Leg flight may be canceled, rescheduled, or materially changed at any time if the
          underlying operational need changes or disappears.
        </p>
        <p>This includes situations where:</p>
        <ul>
          <li>the primary charter is canceled or changed</li>
          <li>the aircraft is no longer required to reposition as planned</li>
          <li>crew, maintenance, weather, airport, regulatory, or operational constraints arise</li>
          <li>
            the operator determines that the flight can no longer be performed as originally
            anticipated
          </li>
        </ul>
        <p>
          In such circumstances, Airacer will inform the customer as soon as reasonably possible and
          will address any refund, rebooking, or alternative arrangement in accordance with the
          applicable booking terms and operator conditions.
        </p>

        <h2 id="10-customer-cancellation">10. Customer Cancellation</h2>
        <p>
          Customer cancellation of an Empty Leg booking may result in cancellation fees or complete
          forfeiture of amounts paid, depending on:
        </p>
        <ul>
          <li>the timing of cancellation</li>
          <li>operator terms</li>
          <li>whether the flight has already been secured</li>
          <li>whether Airacer or the operator has already incurred non-recoverable costs</li>
        </ul>
        <p>
          Any applicable cancellation terms will be communicated at or before booking confirmation.
        </p>

        <h2 id="11-no-guarantee-of-comparable-replacement">
          11. No Guarantee of Comparable Replacement
        </h2>
        <p>
          If an Empty Leg flight is canceled, changed, or withdrawn, Airacer does not guarantee the
          availability of a replacement Empty Leg flight on the same route, date, timing, or
          aircraft category.
        </p>
        <p>
          Any replacement option will be subject to fresh availability, pricing, and operator
          approval.
        </p>

        <h2 id="12-third-party-operator-terms">12. Third-Party Operator Terms</h2>
        <p>All Empty Leg flights are operated by independent third-party operators.</p>
        <p>
          In addition to this policy, customers may also be subject to the terms, operational
          limitations, and conditions imposed by the operating carrier.
        </p>
        <p>
          Where applicable, operator requirements relating to identification, manifests, catering
          deadlines, pet documentation, baggage, passenger information, and payment timing must be
          satisfied by the customer.
        </p>

        <h2 id="13-payment">13. Payment</h2>
        <p>
          Payment terms for Empty Leg bookings may be stricter due to the nature of short-notice
          inventory.
        </p>
        <p>
          Airacer may require immediate payment, full prepayment, or other accelerated payment
          arrangements in order to secure an Empty Leg flight.
        </p>
        <p>
          An Empty Leg flight will not be considered secured until the required payment has been
          received and confirmed.
        </p>

        <h2 id="14-no-waiver">14. No Waiver</h2>
        <p>
          Any exception, waiver, or special arrangement granted by Airacer in any individual case
          shall not create any obligation for Airacer to grant the same treatment in any other case.
        </p>

        <h2 id="15-final-interpretation">15. Final Interpretation</h2>
        <p>
          Airacer reserves the right to interpret and apply this policy in conjunction with the
          terms communicated for the specific booking, the applicable operator requirements, and any
          governing contractual documents.
        </p>
      </div>
      <Footer />
    </>
  );
};

export default EmptyLegPolicy;
